import React, { useMemo, forwardRef, useRef, useImperativeHandle } from 'react';
import {
  TablePaginatedV8,
  order2Sorting,
  TableCellV8,
  CellCenterV8,
  toastFailure,
} from 'motion-components';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { gridInactiveRowStyle, gridRowSelectedStyle } from 'shared-pages/common/grid-helpfunc';
import { FaFilePdf } from 'react-icons/fa';
import { useApolloClient } from '@apollo/client';
import { gqlGetFilesRepositoryFileUrlById } from '../graphql';

/* ----------- Grid ------------------ */

export const DataGrid = forwardRef((props: any, ref) => {
  const {
    data,
    dataCount,
    initPageIndex,
    onPageChange,
    loading,
    handleExport,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
  } = props;
  const { appStore, tableStore } = useRootStore();
  const { t } = useTranslation();
  const client = useApolloClient();

  const downloadDocument = async (value) => {
    console.log('***OPEN FILE***');
    client
      .query({
        query: gqlGetFilesRepositoryFileUrlById,
        variables: { id: value },
      })
      .then((res) => {
        const url = res?.data?.getFilesrepositoryFileUrlById;
        if (url) {
          window.open(url);
        } else {
          toastFailure(t('Error during file download')); //'Πρόβλημα Στο Κατέβασμα του Αρχείου'
        }
      })
      .catch((err) => toastFailure(t('Error during file download ') + err)); //`Πρόβλημα στο κατέβασμα του αρχείου err:${err}`));
  };

  const columns = useMemo(
    () => [
      {
        id: 'id',
        header: t('ID'),
        columnName: t('ID'),
        accessorKey: 'id',
        orderByField: 'id',
        cell: CellCenterV8,
        size: 5,
      },
      ...(appStore.isPlatformOwner
        ? [
            {
              id: 'name',
              header: t('Υπόχρεος'),
              columnName: t('Υπόχρεος'),
              accessorKey: 'contributor.name',
              orderByField: 'contributor.name',
              cell: TableCellV8,
              size: 50,
              meta: { type: 'text' },
            },
          ]
        : []),
      {
        id: 'year',
        header: t('Έτος'),
        columnName: t('Έτος'),
        accessorKey: 'year',
        orderByField: 'year',
        cell: TableCellV8,
        size: 50,
        meta: { type: 'text' },
      },
      {
        id: 'contributionperiod.name',
        header: t('Περίοδος'),
        columnName: t('Περίοδος'),
        accessorKey: 'contributionperiod.name',
        orderByField: 'contributionperiod.name',
        cell: TableCellV8,
        size: 15,
        meta: { type: 'text' },
      },
      {
        id: 'series.name',
        header: t('Σειρά'),
        columnName: t('Σειρά'),
        accessorKey: 'series.name',
        orderByField: 'series.name',
        cell: TableCellV8,
        size: 25,
        meta: { type: 'text' },
      },
      {
        id: 'invoiceFileId',
        header: t('Αρχείο'),
        columnName: t('Αρχείο'),
        accessorKey: 'invoiceFileId',
        orderByField: 'invoiceFileId',
        size: 25,
        cell: ({ row }) => {
          return (
            <div className="d-flex flex-row justify-content-around">
              <FaFilePdf
                style={{ cursor: 'pointer' }}
                size={'40'}
                color="#F40F02"
                onClick={() => downloadDocument(row.original.invoiceFileId)}
              ></FaFilePdf>
            </div>
          );
        },
      },
    ],
    [t],
  );

  const tableRef = useRef(null);
  // return of useRef
  useImperativeHandle(ref, () => (tableRef.current ? tableRef.current : null));

  return (
    <LoadingOverlay active={loading} spinner text={'Παρακαλώ περιμένετε...'}>
      {data ? (
        <TablePaginatedV8
          ref={tableRef}
          loading={loading}
          id="contributions-old-grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={dataCount}
          topBorderRadius={false}
          onRowClick={(table) => setSelected(table.row.original)}
          rowProps={(row: any) => {
            let style = undefined;
            if (row.original.id === selected?.id) style = gridRowSelectedStyle;
            if (row.original.isActive === false) style = { ...style, ...gridInactiveRowStyle };
            return { style: style };
          }}
          onExport={handleExport}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          initSorting={order2Sorting(initOrderBy)}
          onSortByChange={(sort) => {
            console.log('$$$$ grid sortbychange', sort);
            // $$$
            const columnId = sort[0].id;
            const sortOrder = sort[0].desc ? 'DESC' : 'ASC';
            // find column by id
            const cols = columns.filter((r: any) => r.id === columnId);
            if (cols.length === 1) {
              const col = cols[0] as any;
              let order = col.orderByField ? col.orderByField : 'id';
              order = order + ' ' + sortOrder;
              onOrderChange(order);
            }
          }}
          //onNewRow={() => {}}
          //onSaveRow={async (rowIndex, row, changes) => {}}
          //deleteRow={async (row) => {}}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
  );
});
